// extracted by mini-css-extract-plugin
module.exports = {"container":"deviceError_container___lHbU","fadeImage":"deviceError_fadeImage__3KCoq"};